import helper from './helper'
import VueTheMask from 'vue-the-mask'

export default (app) => {
  app.use(helper)
  app.use(VueTheMask)
  // app.use(moment)
}
